// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1yYOc","content":"styles_content__3P6Jv","selectAll":"styles_selectAll__XpWzb"};